export default "__VITE_ASSET__CuhsXC1g__"